import React from 'react';
import {withTranslation} from 'react-i18next';
import i18next from 'i18next';

class MMetaVillaPage extends React.Component {
    componentDidMount() {
        require('../../common/mweb/css/index.css');
    }

    changeLanguage = (lang) => {
        i18next.changeLanguage(lang);
    };

    render() {
        const {t} = this.props;

        // imageUrl 생성
        let imagePostfix = '.png';
        if (i18next.language === 'en') {
            imagePostfix = '_en.png';
        } else if (i18next.language === 'zh') {
            imagePostfix = '_zh.png';
        }
        const imageUrl = `https://981park-jeju-asset.s3.ap-northeast-2.amazonaws.com/www/common/mweb/img/sub/event/img-metavilla1${imagePostfix}`;

        const headerHeight = '54px';

        return (
            <>
                <header style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    zIndex: 1000,
                    boxSizing: 'border-box',
                    height: headerHeight,
                    backgroundColor: '#000000',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingLeft: '24px',
                    paddingRight: '24px'
                }}>
                    <div className="logo" style={{display: 'flex', alignItems: 'center'}}>
                        <img
                            src="https://asset.981park.com/www/common/web/img/common/logo/981-park.svg"
                            alt="981 PARK"
                            style={{
                                width: '94.7px',
                                height: '30px',
                                cursor: 'pointer'
                            }}
                            onClick={() => window.open('https://981park.com', '_blank', 'noopener,noreferrer')}
                        />
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '19px'}}>
                        <span className="typo1" style={{color: 'white', fontSize: '15px', cursor: 'pointer'}}
                              onClick={() => this.changeLanguage('ko')}>{t('Lang_ko')}</span>
                        <span className="typo1" style={{color: 'white', fontSize: '15px', cursor: 'pointer'}}
                              onClick={() => this.changeLanguage('en')}>{t('Lang_en')}</span>
                        <span className="typo1" style={{color: 'white', fontSize: '15px', cursor: 'pointer'}}
                              onClick={() => this.changeLanguage('zh')}>{t('Lang_zh')}</span>
                    </div>
                </header>

                <div className="park-wrap" style={{paddingTop: headerHeight}}>
                    <div className="info">
                        <div className="img-wrap">
                            <div className="img">
                                <img
                                    src={imageUrl}
                                    alt={t("MetaVilla_altText")}
                                    title={t("MetaVilla_titleText")}
                                    style={{width: '100%', height: 'auto'}}
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(MMetaVillaPage);